/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/UI/Navigation',[
    'jquery',
    'global/Logger'
], function ($, Logger) {
    var breakpoint = 940;

    // Only need to include if you haven't already elsewhere
    // Getting .width() with window isn't going to account for the scrollbar
    // So we get the innerWidth or clientWidth depending on which size is smaller
    function getViewportW() {
        var win = typeof window != 'undefined' && window,
            doc = typeof document != 'undefined' && document,
            docElem = doc && doc.documentElement;

        var a = docElem['clientWidth'], b = win['innerWidth'];
        return a < b ? b : a;
    }

    function init() {
        /*! CLICK NAVIGATION FUNCTIONALITY */
        /*! TODO - Turn into plugin | Possibly put in JS fallbacks but I'm fine with progressive enhancement | More Animation options */

        // Note that you may need to change the breakpoint based on when you make the mobile switch
        var $menu = $('.js-clickMenu'),
			animationSpeed = 400;

        $menu.each(function () {
            var $thisMenu = $(this),
				isOmegaMenu = $thisMenu.hasClass('omegaMenu');

            //Add class to remove any functionality if JS failed
            $thisMenu.addClass('js-enabled');

            //Bind MENU Toggle if there is one
            $thisMenu.find('.menuToggle').on('click', function (e) {
                e.preventDefault();

                if ($('body').hasClass('js-menu-active')) {
                    $('body').off('click touchstart', menuToggleHandler);
                } else {
                    $('body').on('click touchstart', menuToggleHandler);
                }

                $('body').toggleClass('js-menu-active');
            });

            $thisMenu.find('ul a').each(function () {
                var $anchor = $(this),
					hasSubs = false;

                //Has Subs comparison changes depending on mega or not

                // Have anchor do what it normally would do unless it has subs
                if ($anchor.next('div.subMenu, div.omegaMenu-sub, ul').length > 0) {
                    //Style it up via class
                    $anchor.addClass('hasSub');

                    // bind click functionality for anchors
                    $anchor.on('click', function (e) {
                        var $currAnchor = $(this),
							$parentLi = $currAnchor.closest('li'),
							isMainTier = $currAnchor.siblings().hasClass('subMenu'),
							isMega = $thisMenu.find('.megaMenu').length > 0,
							takeOver = true;

                        if (isMega && getViewportW() >= breakpoint && !isMainTier) {
                            takeOver = false;
                        } else if (getViewportW() < breakpoint && !isMainTier) {
                            // if small screen and not main tier use default
                            takeOver = false;
                        }

                        if (takeOver) {
                            // Prevent other handlers
                            e.preventDefault();

                            $('body').off('click touchstart', menuHandler);

                            if ($parentLi.hasClass('opened') && isMainTier) {
                                $parentLi.removeClass('opened animating animated');

                                if (isOmegaMenu) {
                                    handleOmegaMenu(e, isMainTier, $currAnchor, $parentLi);
                                };

                                if ($thisMenu.find('opened').length > 0) {
                                    $('body').on('click touchstart', menuHandler);
                                }

                            } else {
                                // Otherwise Open submenu and attach body click handler
                                // Also - close any other open menus and their children
                                $parentLi.siblings().removeClass('opened animating animated')
										 .find('.opened').removeClass('opened animating animated');

                                $parentLi.addClass('opened animating');


                                if (isOmegaMenu) {
                                    handleOmegaMenu(e, isMainTier, $currAnchor, $parentLi);
                                };

                                setTimeout(function () {
                                    if ($parentLi.hasClass('animating')) {
                                        $parentLi.removeClass('animating').addClass('animated');
                                    }
                                }, animationSpeed);

                                $('body').on('click touchstart', menuHandler);
                            }
                        }
                    });
                };
            });

            if (isOmegaMenu) {
                $('<div />', {
                    'class': 'omegaMenu-sub omegaMenu-helper',
                    style: 'transition:none; left:-999999em'
                }).appendTo($thisMenu.find('.omegaMenu-sub').parent());
            }
        });

        function menuToggleHandler(e) {
            if ($(e.target).parents('.js-clickMenu').length <= 0) {
                $('.menuToggle').trigger('click');
                $('body').off('click touchstart', menuToggleHandler);
            }
        }

        function menuHandler(e) {
            if ($(e.target).parents('.js-clickMenu').length <= 0) {
                $menu.find('.opened').removeClass('opened animated animating');
                $('body').off('click touchstart', menuHandler);
            }
        }
    };

    function handleOmegaMenu(e, isMainTier, $currAnchor, $parentLi) {
        if (window.matchMedia('(min-width:' + breakpoint + 'px)').matches) {
            var mainLevel;

            if (isMainTier) {
                mainLevel = $currAnchor.next('.subMenu')
                mainLevel.find('[data-default-open=\'true\']').addClass('opened animated');
            } else {
                mainLevel = $currAnchor.closest('.subMenu')
            }

            var mainLevelContent = mainLevel.find('> .subMenu-content').removeAttr('style'),
				mainLevelSecondary = mainLevel.find('> .subMenu-content > .subMenu-secondary').removeAttr('style'),
				currentSub = $parentLi.find('.omegaMenu-sub:first').removeAttr('style'),
				currentSubHelper = currentSub.next('.omegaMenu-helper'),
				mainLevelUL = mainLevelContent.children('ul:first'),
				mainLevelSizeW = parseFloat(mainLevelUL.css('width')),
				mainLevelSizeH = parseFloat(mainLevelUL.css('max-height', 'none').css('height')),
				mainLevelSecondarySizeW = parseFloat(mainLevelSecondary.css('width')),
				mainLevelSecondarySizeH = parseFloat(mainLevelSecondary.css('height')),
				currentSubHelperSizeW = parseFloat(currentSubHelper.css('width')),
				menuWidth = 0,
				menuHeight = 0;

            mainLevelUL.removeAttr('style')

            if (isMainTier && (mainLevelSecondary.length > 0)) {
                menuWidth = mainLevelSizeW + mainLevelSecondarySizeW;
                menuHeight = Math.max(mainLevelSizeH, mainLevelSecondarySizeH, currentSub.height());
                mainLevelSecondary.css('height', menuHeight);
            } else {
                menuWidth = mainLevelSizeW + currentSubHelperSizeW;
                menuHeight = Math.max(mainLevelSizeH, currentSub.height());
                currentSub.css('height', menuHeight);
            }

            mainLevelContent.css({ "height": menuHeight, "width": menuWidth });
        };
    };


    // Initialize mainNavigation
    init();

    var Navigation = { init: init };

    Logger.debug('Navigation.js Loaded:', Navigation);

    return Navigation;
});


